/**
 * @desc 查询可邀约人员
 */
import {
  PageProfileUser,
  AuctionUserPageParam
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryAuctionUserPageParameter = AuctionUserPageParam

const method = 'GET'
const url = '/trade/operation/auction/users'

export const queryAuctionUserPageApi = (
  params?: QueryAuctionUserPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageProfileUser>({
    method,
    url,
    params,
    ...config
  })
}

queryAuctionUserPageApi.method = method
queryAuctionUserPageApi.url = url
